/**
 * @desc 数据推送
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.PushRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/test/push`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
